import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  save: {
    defaultMessage: 'Save',
    id: '3NYL/r',
    description: 'Save receiving orders',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'vY9SaO',
    description: 'Cancel purchase order button',
  },
  receiveStock: {
    id: 'wU/I0y',
    defaultMessage: 'Receive Stock',
    description: 'Button label for receiving stock',
  },
  bannerContent: {
    id: 'BpRenI',
    defaultMessage: '<b>Need help adding products?</b> Learn how to add products either through a scanner or manual entry.',
    description: 'Instructions for scanning products in the receive stock drawer',
  },
  learnMore: {
    id: 'y8tKo8',
    defaultMessage: 'Learn more',
    description: 'Link text for learn more section',
  },
  scanInstructions: {
    defaultMessage: 'Scan or enter UPC/SKU and adjust any details as needed',
    id: 'uAtndw',
    description: 'Instructions for purchase order receive form',
  },
  warehouse: {
    defaultMessage: 'Warehouse',
    id: 'gfrv/W',
    description: 'Warehouse label for for purchase order receive form',
  },
});
